import { render, staticRenderFns } from "./FreezingEachList.vue?vue&type=template&id=7596e0a1&"
import script from "./FreezingEachList.vue?vue&type=script&lang=js&"
export * from "./FreezingEachList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports